import {IndicatorGraph, SerieGraph} from "../../services/interface/catalogs/serie-graph";

export const CreditDataGraphMock: SerieGraph[] = [
    {
        name: 'Real',
        data: [50, 25, 60, 31, 10, 40, 120],
        color: "#67debe",
    },
    {
        name: 'Forecast',
        data: [10, 45, 80, 82, 10, 70, 110],
        color: "#3a6379",
    },
];

export const CreditDataGraph2Mock: SerieGraph[] = [
    {
        name: 'Real',
        data: [50, 30, 40, 45, 50, 49, 60],
        color: "#3a6379",
    },
    {
        name: 'Forecast',
        data: [20, 55, 40, 92, 50, 20, 160],
        color: "#67debe",
    },
];

export const IndicatorsGraphMock: IndicatorGraph[] = [
    {
        icon: 'InsertChartTwoTone',
        tooltip: 'Tasa A',
        value: '0%',
    },{
        icon: 'TroubleshootTwoTone',
        tooltip: 'Tasa B',
        value: '0%',
    },{
        icon: 'StackedBarChartTwoTone',
        tooltip: 'Tasa C',
        value: '0%',
    },{
        icon: 'TrendingDownTwoTone',
        tooltip: 'Tasa E',
        value: '0%',
    },{
        icon: 'ShutterSpeedTwoTone',
        tooltip: 'Tasa X',
        value: '0%',
    }
];
